import dayjs from 'dayjs'
import find from 'lodash/find'
import includes from 'lodash/includes'

export const isLicenseExpired = ({ identifiers, licenses }) => {
  if ( licenses.length === 0 ) return false
  const { vbid, expiration } = find(licenses, license => license )
  const today = dayjs()

  return includes(identifiers, vbid) && dayjs(expiration).isBefore(today)
}

export const isLicenseValid = ({ licenses, identifiers }) => {
  if ( licenses.length === 0 ) return false

  const { vbid, expiration } = find(licenses, license => license)

  const today = dayjs()

  return includes(identifiers, vbid) && dayjs(expiration).isAfter(today)
}
